export interface IPlayer {
  lastName: string
  firstName: string
  country: string
  positions: string[]
  strongFoot: string
  height: number
  yearStart: number
  inActivity: string
  clubs: string[]
  goalsCount: number
  championshipTitlesCount: number
  cupTitlesCount: number
  selectionsCount: number
}

export enum CellSize {
  SMALL = 'SMALL',
  MEDIUM = 'MEDIUM',
  LARGE = 'LARGE',
}

export enum CellStatus {
  CORRECT = 'CORRECT',
  ERROR = 'ERROR',
  PARTIAL = 'PARTIAL',
}

export enum CellNumberCmp {
  HIGHER = 'HIGHER',
  LOWER = 'LOWER',
  EQUAL = 'EQUAL',
}

export interface ICellResult {
  size: CellSize
  value?: string
  logos?: string[]
  status: CellStatus
  numberCmp?: CellNumberCmp
}

export const labels = {
  player: '',
  country: 'Nationalité',
  positions: 'Poste(s)',
  strongFoot: 'Pied fort',
  height: 'Taille',
  yearStart: 'Année de début de carrière',
  inActivity: 'En activité',
  clubs: 'Clubs',
  goalsCount: 'Nombre de buts en carrière',
  championshipTitlesCount: 'Nombre de titres de champion de France',
  cupTitlesCount: 'Nombre de coupes de France remportées',
  selectionsCount: 'Nombre de sélections en équipe nationale',
}
